export const version = '0.816.0'
export const chameleonWebVersion = '10.6.2'
export const chameleonCoreVersion = '7.15.1'
